import ManageCampaignFieldbooks from './ManageCampaignFieldbooks'

export default ManageCampaignFieldbooks
